import type { ModuleKey, Permission } from '@alicerce/contracts';
import {
  Banknote,
  Bell,
  BookOpen,
  Boxes,
  CalendarDays,
  CreditCard,
  FileText,
  HandCoins,
  Home,
  Megaphone,
  MessageCircle,
  Package,
  Repeat,
  Settings,
  ShieldCheck,
  ShoppingBag,
  Store,
  Users,
  Wallet,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  module?: ModuleKey;
  permission?: Permission;
}

/** Menu do painel. Módulos inativos continuam no menu e abrem a tela "ative para ver". */
export const NAV: NavItem[] = [
  { to: '/', label: 'Início', icon: Home, permission: 'dashboard:read' },
  { to: '/venda-rapida', label: 'Venda rápida', icon: Zap, permission: 'sales:quick' },
  { to: '/cobrar', label: 'Cobrar cliente', icon: HandCoins, module: 'checkout', permission: 'orders:write' },
  { to: '/produtos', label: 'Produtos', icon: Package, permission: 'catalog:read' },
  { to: '/clientes', label: 'Clientes', icon: Users, permission: 'customers:read' },
  { to: '/loja', label: 'Loja online', icon: Store, module: 'storefront', permission: 'storefront:read' },
  { to: '/agenda', label: 'Agenda', icon: CalendarDays, module: 'agenda', permission: 'bookings:read' },
  { to: '/pedidos', label: 'Pedidos', icon: ShoppingBag, module: 'checkout', permission: 'orders:read' },
  { to: '/assinaturas', label: 'Assinaturas', icon: Repeat, module: 'checkout', permission: 'orders:read' },
  { to: '/checkout', label: 'Pagamento e entrega', icon: Banknote, module: 'checkout', permission: 'orders:read' },
  { to: '/estoque', label: 'Estoque', icon: Boxes, module: 'inventory', permission: 'inventory:read' },
  { to: '/financeiro', label: 'Gastos e lucros', icon: Wallet, module: 'finance', permission: 'finance:read' },
  { to: '/notas', label: 'Notas fiscais', icon: FileText, module: 'fiscal', permission: 'fiscal:read' },
  { to: '/atendimento', label: 'Atendimento', icon: MessageCircle, module: 'inbox', permission: 'inbox:read' },
  { to: '/anuncios', label: 'Anúncios', icon: Megaphone, module: 'ads', permission: 'ads:read' },
];

export const NAV_FOOTER: NavItem[] = [
  { to: '/notificacoes', label: 'Notificações', icon: Bell, permission: 'notifications:read' },
  { to: '/equipe', label: 'Equipe', icon: Users, permission: 'team:read' },
  { to: '/assinatura', label: 'Assinatura', icon: CreditCard, permission: 'billing:read' },
  { to: '/configuracoes', label: 'Configurações', icon: Settings, permission: 'tenant:read' },
  { to: '/ajuda', label: 'Ajuda', icon: BookOpen },
];

export const STAFF_NAV: NavItem = { to: '/interno', label: 'Back-office', icon: ShieldCheck };
